import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const Subtitle = styled.span`
    ${setFontVariant("input2", carbon[500])}
`;

export const Bold = styled(Subtitle)`
    ${setFontVariant("subtitle2", carbon[500])}
`;
export const LabelText = styled.span`
    ${setFontVariant("input2", `${carbon[400]} !important`)}
`;
